import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <header
      className="border-b border-border bg-white px-8 py-6 flex items-start justify-between gap-4"
      data-testid={testid}
    >
      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-2">
          TECSend
        </p>
        <h1 className="font-heading text-2xl md:text-3xl font-medium tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1 max-w-xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}

export function PageBody({ children, className = "" }) {
  return <div className={`px-8 py-8 ${className}`}>{children}</div>;
}
